import 'regenerator-runtime/runtime';
import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import {store} from './_store'
import 'ant-design-vue/dist/antd.css'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

// Upload loading interceptor
let uploadLoadingHides = []
axios.interceptors.request.use(function (config) {
  if (config.url && config.url.includes('/upload/')) {
    const hide = Vue.prototype.$message.loading('Nahrávam a optimalizujem obrázok...', 0)
    config._uploadHide = hide
    uploadLoadingHides.push(hide)
  }
  return config
})
axios.interceptors.response.use(function (response) {
  if (response.config && response.config._uploadHide) {
    response.config._uploadHide()
    uploadLoadingHides = uploadLoadingHides.filter(h => h !== response.config._uploadHide)
  }
  if (response.data && response.data.success === false && response.data.message) {
    Vue.prototype.$message.error(response.data.message)
  }
  return response
}, function (error) {
  if (error.config && error.config._uploadHide) {
    error.config._uploadHide()
    uploadLoadingHides = uploadLoadingHides.filter(h => h !== error.config._uploadHide)
  }
  return Promise.reject(error)
})

Vue.filter('startsWith', function (array, search, field) {
  if (!search.length) return array;

  return array.filter(function(element) {
    return element[field].toLowerCase().indexOf(search.toLowerCase()) === 0;
  })
})
Vue.filter('truncate', function (value, limit) {
  if(value)
  {if (value.length > limit) {
    value = value.substring(0, (limit - 3)) + '...';
  }
    }
  return value
})
import {Table} from 'ant-design-vue';

import FormItem from 'ant-design-vue'

Vue.use(FormItem);
Vue.use(Table);
import CKEditor from '@ckeditor/ckeditor5-vue2';
import * as LucideIcons from 'lucide-vue';

Vue.use( CKEditor );

// Registrácia Lucide ikon ako globálnych komponentov s prefixom Lucide
// Použitie: <LucidePalette />, <LucideFlame /> atď.
Object.entries(LucideIcons).forEach(([name, component]) => {
  if (typeof component === 'object' && component.render) {
    Vue.component('Lucide' + name, component);
  }
});
Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)

import './override.css'; // variables to override above
new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
